module.exports = __webpack_public_path__ + "img/print.b82ac3b4.svg";